import { BundleClient } from '@frontend/bundle/api';
import { Application } from '@frontend/functionality/types';
import { useAccountRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';

import { BundleUsageBannerState, resolveBundleUsageBanner } from './application-bundle-usage.utils';

export interface ApplicationBundleUsageLayoutViewProps {
    showBanner: boolean;
    banner: BundleUsageBannerState | null;
    onDismiss: () => void;
}

export const useApplicationBundleUsageLayout = (application: Application): ApplicationBundleUsageLayoutViewProps => {
    const { currentAccount } = useAccountRepository();
    const [dismissed, setDismissed] = useState(false);
    const [banner, setBanner] = useState<BundleUsageBannerState | null>(null);

    useEffect(() => {
        setDismissed(false);
        setBanner(null);

        if (!currentAccount) {
            return;
        }

        let cancelled = false;

        BundleClient.fetchVerifiedBundles({ account_id: currentAccount, application })
            .then((response) => {
                if (!cancelled) {
                    setBanner(resolveBundleUsageBanner(response.results ?? []));
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setBanner(null);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [currentAccount, application]);

    return {
        showBanner: !dismissed && banner != null,
        banner,
        onDismiss: () => setDismissed(true)
    };
};
